import React from 'react'
import {Icon} from '@chakra-ui/react'
const AddIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" data-testid="add-icon" {...props} aria-hidden="true">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.6024 19.3999V8.59988C20.6024 8.26868 20.3336 7.99988 20.0024 7.99988C19.6712 7.99988 19.4024 8.26868 19.4024 8.59988V19.3999H8.6C8.2688 19.3999 8 19.6687 8 19.9999C8 20.3311 8.2688 20.5999 8.6 20.5999H19.4024V31.3999C19.4024 31.7311 19.6712 31.9999 20.0024 31.9999C20.3336 31.9999 20.6024 31.7311 20.6024 31.3999V20.5999H31.4C31.7312 20.5999 32 20.3311 32 19.9999C32 19.6687 31.7312 19.3999 31.4 19.3999H20.6024Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default AddIcon
